/**
 * E-commerce Shipping Configurations & Thresholds
 * 
 * Free shipping is unlocked when cart product total meets or exceeds this threshold.
 * Configured in tandem with backend Bosta:FreeShippingThreshold.
 */
export const FREE_SHIPPING_THRESHOLD = 2000;

/**
 * Checks if the subtotal qualifies for free shipping
 * @param {number|string} subtotal 
 * @param {number} [threshold=FREE_SHIPPING_THRESHOLD] 
 * @returns {boolean}
 */
export function isFreeShippingEligible(subtotal, threshold = FREE_SHIPPING_THRESHOLD) {
  return Number(subtotal || 0) >= threshold;
}

/**
 * Returns remaining amount needed to qualify for free shipping (0 if already qualified)
 * @param {number|string} subtotal 
 * @param {number} [threshold=FREE_SHIPPING_THRESHOLD] 
 * @returns {number}
 */
export function getFreeShippingRemaining(subtotal, threshold = FREE_SHIPPING_THRESHOLD) {
  return Math.max(0, threshold - Number(subtotal || 0));
}

/**
 * Returns progress percentage towards free shipping (0 to 100)
 * @param {number|string} subtotal 
 * @param {number} [threshold=FREE_SHIPPING_THRESHOLD] 
 * @returns {number}
 */
export function getFreeShippingProgress(subtotal, threshold = FREE_SHIPPING_THRESHOLD) {
  const current = Number(subtotal || 0);
  if (current <= 0) return 0;
  return Math.min(100, Math.round((current / threshold) * 100));
}
